import React, { useState, useEffect } from "react";
import { Box, Container, Typography } from "@mui/material";
import { useOktaAuth } from "@okta/okta-react";
import { useLocation, useParams } from "react-router-dom";

import Header from "../components/Header";
import Footer from "../components/Footer";
import PatientAnswers1 from "../components/PatientAnswers1";

export default function PatientDetails() {
    const { oktaAuth } = useOktaAuth();
    const [activeTab, setActiveTab] = useState("patients");
    const location = useLocation();

    // Set active tab based on current route
    useEffect(() => {
        if (location.pathname === "/patients") {
            setActiveTab("patients");
        }
    }, [location.pathname]);

    const handleTabChange = (tab: string) => {
        setActiveTab(tab);
    };

    return (
        <Box
            sx={{
                minHeight: "100vh",
                bgcolor: "#f9fbfd",
                display: "flex",
                flexDirection: "column",
            }}
        >
            <Header activeTab={activeTab} onTabChange={handleTabChange} onLogout={() => oktaAuth.signOut()} />

            <Container
                maxWidth="xl"
                sx={{
                    flexGrow: 1,
                    py: 4,
                    px: { xs: 2, md: 4 },
                }}
            >
                <PatientAnswers1 />
            </Container>

            <Footer />
        </Box>
    );
}